import axios from "axios";
import { notification, Modal } from "antd";
import { mainHost, DATA_CODE, ENV, getApplicationUrl } from "../config";

import Cookies from "js-cookie";

// 该token用于测试接口

const errorMap = new Map();

const service = axios.create({
  baseURL: mainHost,
  timeout: 10000,
});

export const IS_TMALL = window.$wujie?.props?.systemid === "100011"

service.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
    if (IS_TMALL) {
      config.headers["system_id"] = 100011;
    }
    const token = Cookies.get("token");

    config.headers["authority_token"] = token;
    /* if (config['method'] === 'get') {
      config.params._date = new Date().getTime()
    } else if (config['method'] === 'post') {
      config.data._date = new Date().getTime()
    } */
    config.url = `${config.url}?__date=${new Date().getTime()}`;
    return config;
  },
  (err) => {
    notification.error({
      title: "发送请求失败",
      message: err,
    });
    return false;
  }
);

let hasErrorOccurred = false; // 控制是否出现过错误的标志

/*异常统一处理通过success 和 code进行区分 */
service.interceptors.response.use(
  (res) => {
    const { status, data, statusText } = res;
    return new Promise((resolve, reject) => {
      if (status < 200 || status > 300) {
        notification.error({
          message: `请求错误: ${status}`,
          description: statusText,
        });
      } else if (!data.success) {
        errorMap.set(data.code, true);

        if (data.code === DATA_CODE.LOGIN_ERROR) {
          if (window.__POWERED_BY_WUJIE__) {
            window.$wujie?.props?.logoutAndGoToLogin?.();
          } else if (window.fleLocation.hostname !== 'localhost') {
            const loginLink = Cookies.get('loginLink');
            const redirectUrl = `?redirectUrl=${encodeURIComponent(window.fleLocation.href)}`;
            window.fleLocation.href = loginLink
              ? `https://${loginLink}`
              : `/account/login${redirectUrl}`;
          }

          return reject(data);
        }

        if (!hasErrorOccurred) {
          hasErrorOccurred = true; // 当第一个接口报错时设置 hasErrorOccurred 为 true
          notification.error({
            message: "提示",
            description: data.message,
            onClose: () => {
              hasErrorOccurred = false; // 当关闭提示时重置 hasErrorOccurred 为 false，允许之后的错误再次触发提示
            },
          });
        }
        return reject(data);
      } else {
        // 目的是如果data为null,则返回整个响应头
        return resolve(data || res);
      }
      return reject();
    });
  },
  (err) => {
    if (!hasErrorOccurred) {
      notification.error({
        message: "提示",
        description: "系统错误",
        onClose: () => {
          hasErrorOccurred = false; // 当关闭提示时重置 hasErrorOccurred 为 false，允许之后的错误再次触发提示
        },
      });
      hasErrorOccurred = true; // 当第一个请求出错时设置 hasErrorOccurred 为 true
    }
    return false;
  }
);
export const getMarketBase = () => {
  let _url = "";
  switch (ENV) {
    case "dev":
      _url = `http://dev-fle.peliten.com`;
      break;
    case "test":
      _url = `https://qa-fle.peliten.com`;
      break;
    default:
      _url = `https://fle.peliten.com`;
  }
  return _url + "/login/index";
};

export default service;
